(() => {
  const ALL_PROVIDERS = 'All providers';

  angular
    .module('app.components')
    .controller('CustomSegmentsController', CustomSegments);

  CustomSegments.$inject = [
    '$q',
    '$scope',
    '$interval',
    '$rootScope',
    'ModalService',
    'CustomSegmentsService',
    'CampaignManagerService'
  ];

  function CustomSegments(
    $q,
    $scope,
    $interval,
    $rootScope,
    ModalService,
    CustomSegmentsService,
    CampaignManagerService
  ) {
    // INIT VM
    let vm = this;
    vm.MAX_CUSTOM_SEGMENTS = 5;
    vm.isLoading = false;
    vm.providerFilter = ALL_PROVIDERS;
    vm.csList = {};
    vm.actionBusy = {};
    vm.actionDisabled = {};

    let originCampaign = {};
    const dataPromises = [
      CustomSegmentsService.getPaginatedCustomSegments('allowed', 0, 1000, 'provider', true)
    ];

    //LOAD DATA
    $q.all(dataPromises)
      .then((response) => {
        vm.segments = response[0].data ? response[0].data.customSegments : [];
        vm.csList = getCustomSegmentsModel(vm.segments);
        vm.isLoading = true;

        setActionDisabled();
      });

    const interval = $interval(() => {
      vm.campaign = CampaignManagerService.getCampaignData();
      originCampaign = angular.copy(vm.campaign);

      if (vm.campaign) {
        $interval.cancel(interval);
      }
    }, 100);

    vm.getSegmentsCount = providerName => {
      const provider = vm.csList.providers.find(provider => provider.name === providerName);
      return provider && provider.segments.filter(segment => vm.searchFilter(segment)).length;
    };

    // HANDLERS
    vm.onSelectProvider = provider => {
      const customSegments = getCustomSegmentsModel(vm.segments);
      vm.providerFilter = provider;

      vm.csList = {
        ...customSegments,
        providers: filterByProvider(customSegments.providers, provider)
      };
    };

    $scope.providerFilter = item => {
      return !!vm.getSegmentsCount(item.name);
    }

    vm.searchFilter = item => {
      const query = vm.query && vm.query.toLowerCase();
      const isIncludes = param => param && param.toLowerCase().includes(query);
      const inProvider = param => param &&
        vm.csList.providers.map(({ name }) => name).includes(param.providerName);

      if (!query) {
        return true;
      }

      if (isIncludes(item.name) && inProvider(item)) {
        return true;
      }

      if (isIncludes(item.description) && inProvider(item)) {
        return true;
      }

      if (item.valueLabels.data.some(option => isIncludes(option.name)) && inProvider(item)) {
        return true;
      }

      return false;
    };

    vm.onExpand = (providerName, segmentName) => {
      vm.csList.providers = vm.csList.providers.map(provider => ({
        ...provider,
        segments: provider.name === providerName ? setExpand(provider.segments, segmentName) : provider.segments
      }));
    };

    vm.onExpandAll = providerName => {
      vm.csList.providers = vm.csList.providers.map(provider => ({
        ...provider,
        segments: provider.name === providerName ? setExpandAll(provider.segments, !provider.expanded) : provider.segments,
        expanded: !provider.expanded,
      }));
    };

    vm.onClear = () => {
      vm.query = '';
    };

    vm.onAddRemove = segment => {
      const isAdded = vm.campaign && vm.campaign.customSegments &&
        vm.campaign.customSegments.some(item => item.csid === segment.csid);

      if (_.isArray(vm.campaign.targetSegment) || typeof vm.campaign.targetSegment === 'string') {
        vm.campaign.targetSegment = {};
      }

      if (isAdded) {
        vm.campaign.customSegments = vm.campaign.customSegments.filter(item => item.csid !== segment.csid);
        delete vm.campaign.targetSegment[segment.csid];
        setActionDisabled();
      } else if (!limitReached()) {
        const { csid } = segment;
        vm.actionBusy[csid] = true;

        setActionDisabled(true);
        getIsAvailablePromise(segment).then(({ data }) => {
          vm.actionBusy[csid] = false;
          if (data && data.available) {
            addSegment(segment);
            setActionDisabled();
          } else {
            showUnavailableWarning(segment);
          }
        });
      }
    };

    vm.isAdded = segment => (vm.campaign && vm.campaign.customSegments &&
      vm.campaign.customSegments.some(item => item.csid === segment.csid));

    vm.dropChanges = () => {
      if (vm.campaign && !_.isEmpty(originCampaign)) {
        vm.campaign.customSegments = angular.copy(originCampaign.customSegments);
        vm.campaign.targetSegment = angular.copy(originCampaign.targetSegment);
      }
    };

    vm.getProviderShortName = (name) => {
      if (!name) {
        return 'N/A';
      }

      const words = name.trim().split(/\s+/, 2);
      return words.length === 1 ? words[0].substr(0, 2) : words.map(item => item[0]).join('');
    }

    $scope.$watch(() => vm.campaign,
      campaign => {
        if (campaign) {
          CampaignManagerService.setCampaignData(campaign)
        }
      }, true);

    $scope.$watch(() => $rootScope.dropSidebarChanges,
      () => vm.dropChanges(), true);

    $scope.$watch(vm.query, () => {
      const initialProviders = getProviders(vm.segments);

      if (vm.csList.providers) {
        vm.csList.providers = filterByProvider(initialProviders, vm.providerFilter)
          .map(provider => ({
            ...provider,
            segments: provider.segments
              .filter(segment => vm.searchFilter(segment))
              .map(segment => ({...segment, expanded: !!vm.query}))
          }));
      }
    });

    function addSegment(segment) {
      vm.campaign.customSegments.push(segment);

      vm.campaign.targetSegment[segment.csid] = [];
      angular.forEach(segment.valueLabels.data, label => {
        vm.campaign.targetSegment[segment.csid].push(label.value);
        label.checked = true;
      });
    }

    function showUnavailableWarning(segment) {
      ModalService
        .showModal({
          templateUrl: '../../assets/js/app/components/customSegments/customSegmentsWarning.html',
          controller: 'CustomSegmentsWarningController',
          controllerAs: 'csWarning',
        }).then(modal => {
          modal.element.modal();
          modal.close.then(proceed => {
            if (proceed) {
              addSegment(segment);
            }
            setActionDisabled();
          });
        });
    }

    function getIsAvailablePromise(segment) {
      const { csid } = segment;
      const { c_start, panel_country, start, } = vm.campaign;

      return CustomSegmentsService.isAvailable({
        csid,
        startDate: start ? new Date(start) : (c_start ? new Date(c_start) : new Date()),
        countryCode: panel_country
      }).$promise;
    }

    function setActionDisabled(forced) {
      if (vm.segments) {
        const status = {};
        vm.segments.forEach(segment => {
          status[segment.csid] = !vm.isAdded(segment) && limitReached() || forced;
        });
        vm.actionDisabled = { ...status };
      }
    }

    function limitReached() {
      return vm.campaign && vm.campaign.customSegments &&
        vm.campaign.customSegments.length === vm.MAX_CUSTOM_SEGMENTS;
    }
  }

  function getCustomSegmentsModel(segments) {
    return {
      providerList: [ALL_PROVIDERS, ...Object.keys(getProvidersGroups(segments))],
      providers: getProviders(segments),
    };
  }

  function filterByProvider(providers, providerName) {
    return providers.filter(provider => providerName === ALL_PROVIDERS || providerName === provider.name);
  }

  function getProvidersGroups(segments) {
    return _.groupBy(segments, segment => segment.providerName);
  }

  function getProviders(segments) {
    const groups = getProvidersGroups(segments);
    return Object.keys(groups)
      .sort()
      .map(provider => ({
        name: provider,
        logo: groups[provider][0].providerLogo,
        segments: _.sortBy(groups[provider], segment => segment.name).map(segment => ({
          ...segment,
          expanded: false
        })),
        expanded: false,
      }));
  }

  function setExpandAll(segments, expanded) {
    return segments.map(segment => ({
      ...segment,
      expanded,
    }));
  }

  function setExpand(segments, segmentName) {
    return segments.map(segment => ({
      ...segment,
      expanded: segment.name === segmentName ? !segment.expanded : segment.expanded
    }));
  }

})();
